import React from "react";
import Pin from "../../images/lbs/pin.svg";
import PropTypes from "prop-types";
import { Divider } from "antd";

function SearchResults(props) {
  const {
    showDivider = false,
    distance = "8 K.M",
    name = "دفتر پیشخوان دولت",
    location = "تهران",
    coordinate = () => false,
    summary = "",
  } = props;

  return (
    <React.Fragment>
      <div className="result-box">
        <div className="distance">
          <img src={Pin} alt="pin" className="icon" />
          <div className="text">{distance}</div>
        </div>
        <div className="place">
          <div className="name">{name}</div>
          <div className="summary">
            <small>{summary}</small>
          </div>
          <div className="location">{location}</div>
        </div>
        <div className="go-to-location" onClick={coordinate}>
          <span className="icon-lbs-10" />
        </div>
      </div>
      {showDivider && <Divider className="search-result-divider" />}
    </React.Fragment>
  );
}

SearchResults.propTypes = {
  distance: PropTypes.string,
  name: PropTypes.string,
  location: PropTypes.string,
  coordinate: PropTypes.func,
};

export default SearchResults;
